// extracted by mini-css-extract-plugin
export default {"root":"ViewSwitcherItem_root__f8zC6","root--active":"ViewSwitcherItem_root--active__vm4Be","inner":"ViewSwitcherItem_inner__tNh71"};